import script from "./ProjectShare.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectShare.vue?vue&type=script&setup=true&lang=js"

import "./ProjectShare.vue?vue&type=style&index=0&id=22eebe22&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22eebe22"]])

export default __exports__